/**
 * @generated SignedSource<<4294461b46e77b0c53d9490948abe6a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRowMetadata$data = {
  readonly closedIssueCount: number;
  readonly openIssueCount: number;
  readonly progressPercentage: number;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMenu">;
  readonly " $fragmentType": "MilestoneRowMetadata";
};
export type MilestoneRowMetadata$key = {
  readonly " $data"?: MilestoneRowMetadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMetadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRowMetadata",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMenu"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openIssueCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedIssueCount",
      "storageKey": null
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "702bb4226f4ee0eedf4e4413804be08d";

export default node;
